/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { authFromDeviceRequestRequestSchema } from "./authFromDeviceRequestRequestSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { tokensSchema } from "./tokensSchema.ts";

export const deviceAuthCreateStatus200Schema = tokensSchema.describe("Сериализатор вывода токена - для документации.");

export const deviceAuthCreateStatus400Schema = errorResponseSchema;

export const deviceAuthCreateResponseSchema = z.union([deviceAuthCreateStatus200Schema, deviceAuthCreateStatus400Schema]);

export const deviceAuthCreateDataSchemaJson = authFromDeviceRequestRequestSchema;

export const deviceAuthCreateDataSchemaXml = authFromDeviceRequestRequestSchema;

export const deviceAuthCreateDataSchema = z.union([deviceAuthCreateDataSchemaJson, deviceAuthCreateDataSchemaXml]);
